// extracted by mini-css-extract-plugin
export default {"composer":"ChatComposer_composer__WQE1S","input":"ChatComposer_input__vqFms","sendButton":"ChatComposer_sendButton__5ui0C"};